import dayjs from 'dayjs';
import type { DateRangePreset } from '../stores/guestRideStore';

export function getDateRangeFromPreset(preset: DateRangePreset): { start: string; end: string } {
  switch (preset) {
    case 'today':
      return { start: dayjs().startOf('day').format(), end: dayjs().endOf('day').format() };
    case 'yesterday':
      return {
        start: dayjs().subtract(1, 'day').startOf('day').format(),
        end: dayjs().subtract(1, 'day').endOf('day').format(),
      };
    case 'thisweek':
      return { start: dayjs().startOf('week').format(), end: dayjs().endOf('week').format() };
    case 'lastweek':
      return {
        start: dayjs().subtract(1, 'week').startOf('week').format(),
        end: dayjs().subtract(1, 'week').endOf('week').format(),
      };
    case 'thismonth':
      return { start: dayjs().startOf('month').format(), end: dayjs().endOf('month').format() };
    case 'lastmonth':
      return {
        start: dayjs().subtract(1, 'month').startOf('month').format(),
        end: dayjs().subtract(1, 'month').endOf('month').format(),
      };
    default:
      return { start: '', end: '' };
  }
}

export function isPickerDisabled(preset: DateRangePreset): boolean {
  return preset !== 'custom';
}

export function getEffectiveDateRange(
  dateRange: DateRangePreset,
  startDate: string,
  endDate: string,
): { start: string; end: string } | null {
  if (dateRange === 'custom') {
    if (!startDate || !endDate) return null;
    return { start: startDate, end: endDate };
  }
  return getDateRangeFromPreset(dateRange);
}
